export default __webpack_public_path__ + "static/topviewofbench-a1795672a401e870ae6c10d1a8697c8d.png";